export default "__VITE_ASSET__512c7e39__"